module.exports = __webpack_public_path__ + "static/media/83.674c1dcf.jpg";